import React from 'react'
import * as Components from '../components/members'

function DeletionRequestsPage() {
  return <Components.DeletionRequestsTable />
}
export default DeletionRequestsPage
